import TickIcon from '../../../../assets/icons/TickIcon';
import { formatCurrency } from '../../../../utils/global';
import styles from './productSearch.module.css';

interface Props {
  product: any;
  isChecked: boolean;
  previewProducts: any[];
  setPreviewProducts: React.Dispatch<React.SetStateAction<any[]>>;
  index: number;
  maximumAllowedSelection?: number | null;
  defaultCurrency: string;
}

export default function ProductSearchDropdownItem({
  product,
  isChecked,
  previewProducts,
  setPreviewProducts,
  index,
  maximumAllowedSelection,
  defaultCurrency,
}: Props) {
  return (
    <div
      key={product?.id}
      className={`${styles.productCard} cursor-pointer items-center mb-2 mx-3 px-3 ${index === 0 ? 'mt-3' : ''}`}
      style={{
        backgroundColor: isChecked ? 'var(--purple-p-10)' : '',
      }}
      role="button"
      tabIndex={0}
      onClick={(e) => {
        e.stopPropagation();
        if (!isChecked) {
          if (maximumAllowedSelection && previewProducts.length === maximumAllowedSelection) {
            return;
          }
          setPreviewProducts([
            ...previewProducts,
            {
              id: product?.id,
              name: product?.name,
              price: product?.price,
              image: product?.image,
            },
          ]);
        } else {
          setPreviewProducts(previewProducts?.filter((p) => p?.id !== product?.id));
        }
      }}
    >
      <div className="flex flex-start gap-2 items-center">
        <img src={product?.image} alt={product?.name} />
        <div className={styles.productNameContainer}>
          <h3 className={`${styles.productName} ${isChecked ? 'text-highlight' : ''}`}>{product?.name}</h3>
          <p className={`${styles.productPrice} ${isChecked ? 'text-highlight' : ''}`}>
            {formatCurrency(Number(product?.price), defaultCurrency)}
          </p>
        </div>
      </div>
      {isChecked && <TickIcon color="var(--icon-highlight)" width={14} height={14} />}
    </div>
  );
}
